import { Cancel as CancelIcon } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import IconButton from '../Button/IconButton'
import TextField from './TextField'

export type SearchFieldProps = {
	initialSearchText?: string
	onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	onClearSearchClick?: () => void
}

const SearchField = ({
	initialSearchText,
	onSearchChange,
	onClearSearchClick,
}: SearchFieldProps) => {
	const [searchText, setSearchText] =
		React.useState(initialSearchText)
	const { formatMessage } = useIntl()

	const handleSearchChange = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		setSearchText(e.target.value)
		onSearchChange?.(e)
	}

	const handleClearSearchClick = () => {
		setSearchText('')
		onClearSearchClick?.()
	}
	return (
		<TextField
			name="search"
			label={formatMessage({ id: 'global.search' })}
			className="w-full sm:max-w-52"
			onChange={handleSearchChange}
			value={searchText}
			InputProps={
				searchText
					? {
							endAdornment: (
								<div className="absolute flex h-full items-center right-0">
									<IconButton
										edge="end"
										onClick={handleClearSearchClick}
										size="small"
										className="!p-0"
										data-cy="clear-search-button"
										aria-label={formatMessage({
											id: 'global.clear_search',
										})}
									>
										<CancelIcon fontSize="small" />
									</IconButton>
								</div>
							),
						}
					: undefined
			}
		/>
	)
}

export default SearchField
